module.exports = new __parcel__URL__("apply_c_faq_closed_btn_ja.f1256abe.webp").toString();